/** Returns true if `value` is of type [[DateAfter]]. */
export function isDateAfterType(value) {
    return Boolean(value && typeof value === 'object' && 'after' in value);
}
//# sourceMappingURL=isDateAfterType.js.map